export default __webpack_public_path__ + "static/problem_back-e908ca96f6cf79e60d511824725c9d91.webp";